var render = function render(_c,_vm){return _c('BravadoText',{staticClass:"members-only-label",class:_vm.data.staticClass || '',attrs:{"variant":"caption1-semibold"}},[_c('img',{attrs:{"src":require('./assets/bravado-logo.svg'),"alt":"","width":"14","height":"14"}}),_vm._v("\n  Members only\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }